import React from 'react';
import Box from '@mui/material/Box';
import arrow from '../../../assets/Icons/arrow.svg';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import lock from '../../../assets/Icons//modules/Course locked.svg';
import { useAlert } from '../../../hooks/useAlert';

export const Moddetails = ({
  open,
  state,
  setSelectedTopic,
  module,
  isCourseModal,
  selectedTopic,
  selectedModule,
  moduleNo,
  moduleHandler,
}) => {
  const { displayAlert } = useAlert();

  const activeTopicHandler = (index) => {
    setSelectedTopic(index);
  };

  // const openModule = module;
  // const selectedModuleId = 2;
  // const selectedTopicId = 2;

  const activeHandler = (index) => {
    if (module.lockStatus != 'LOCKED') {
      activeTopicHandler(index);
      moduleHandler(moduleNo);
    } else {
      displayAlert({
        open: true,
        message: 'Module is Locked',
        type: 'error',
        timeout: '2000',
      });
    }
  };

  return (
    <>
      <Accordion
        disableGutters
        key={moduleNo}
        sx={{
          '&:before': {
            display: 'none',
          },
          paddingRight: '10px',
          backgroundColor: 'var(--pwhite)',
        }}
        elevation={0}>
        <AccordionSummary
          sx={{
            margin: '0px',
            // width: open ? '370px' : '0px',
            paddingRight: '10px',
          }}
          expandIcon={
            open && (
              <img
                width={'13px'}
                src={arrow}
                alt=""
              />
            )
          }
          aria-controls="panel1a-content"
          id="panel1a-header">
          <div className={!open ? 'module__chap' : 'module__chapActive'}>
            <h5 className="ftwt__r module__track">
              <Box
                sx={{
                  border:module?.lockStatus === 'COMPLETE'
                      ? '2px solid var(--pmain)'
                      :
                    '2px solid  var(--grey300)',
                  width: '25px',
                  height: '25px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                <h5
                  style={
                    {
                      // color:
                      //   moduleNo === selectedModule ||
                      //   module?.lockStatus === 'COMPLETE'
                      //     ? 'var(--pmain)'
                      //     : '',
                    }
                  }>
                  {moduleNo + 1}
                </h5>
              </Box>
            </h5>
            {open && (
              <h5
                className="ftwt__r module__name">
                {module?.name}
              </h5>
            )}
            {module.lockStatus === 'LOCKED' && open && <img src={lock} style={{ paddingRight:"10px"}}/>}
            {/* {module.lockStatus === 'COMPLETE' && open && (
              <CheckIcon sx={{ color: 'var(--pmain)', fontSize: '18px' }} />
            )} */}
            {/* <img src={done}/> */}
          </div>
        </AccordionSummary>
        {open && (
          <AccordionDetails>
            <div className="module__topics">
              {module &&
                module?.submodules.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => activeHandler(index)}
                    className="module__topicsdiv    module__active">
                    <h5
                      style={{
                        fontWeight:
                          moduleNo === selectedModule &&
                          index === selectedTopic &&
                          '600',
                      }}
                      className={
                        (moduleNo === selectedModule &&
                          index === selectedTopic) ||
                        (item?.lockStatus === 'COMPLETE' &&
                          !isCourseModal)
                          ? 'ftwt__r module__topicsActive'
                          : 'ftwt__r'
                      }>
                      {moduleNo + 1}.{index + 1}
                    </h5>
                    <h5
                      style={{
                        fontWeight:
                          moduleNo === selectedModule &&
                          index === selectedTopic &&
                          '600',
                      }}
                      className={
                        (moduleNo === selectedModule &&
                          index === selectedTopic) ||
                        (item?.lockStatus === 'COMPLETE' &&
                          !isCourseModal)
                          ? 'ftwt__r module__topicsActive'
                          : 'ftwt__r'
                      }>
                      {item?.name}
                    </h5>
                  </div>
                ))}
            </div>
          </AccordionDetails>
        )}
      </Accordion>
    </>
  );
};
